var React = require("react");
const createReactClass = require("create-react-class");

var InviteFormMessage = createReactClass({

	render: function() {
		if(!this.props.message.className || !this.props.message.text) {
			return null;
		}
		return (
			<div className={this.props.message.className}>
				{this.props.message.text}
			</div>
		);
	}
});

module.exports = InviteFormMessage;
